import { createFileRoute } from "@tanstack/react-router";
import { BetaAdmin } from "@/features/beta/beta-admin";
export const Route = createFileRoute("/beta-admin")({ component: BetaAdmin });
